import React from 'react';

export const TabError = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3151_101638)">
                <mask
                    id="mask0_3151_101638"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                >
                    <path d="M16 0H0V16H16V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_3151_101638)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.0001 2.13516C4.76004 2.13516 2.13345 4.76175 2.13345 8.00182C2.13345 11.2419 4.76004 13.8685 8.0001 13.8685C11.2402 13.8685 13.8668 11.2419 13.8668 8.00182C13.8668 4.76175 11.2402 2.13516 8.0001 2.13516ZM0.533447 8.00182C0.533447 3.87809 3.87639 0.535156 8.0001 0.535156C12.1239 0.535156 15.4668 3.87809 15.4668 8.00182C15.4668 12.1256 12.1239 15.4685 8.0001 15.4685C3.87639 15.4685 0.533447 12.1256 0.533447 8.00182ZM8.0001 4.53516C8.44194 4.53516 8.8001 4.89332 8.8001 5.33516V8.00182C8.8001 8.44366 8.44194 8.80182 8.0001 8.80182C7.55829 8.80182 7.20011 8.44366 7.20011 8.00182V5.33516C7.20011 4.89332 7.55829 4.53516 8.0001 4.53516ZM7.20011 10.6685C7.20011 10.2267 7.55829 9.86846 8.0001 9.86846H8.00682C8.44858 9.86846 8.80682 10.2267 8.80682 10.6685C8.80682 11.1103 8.44858 11.4685 8.00682 11.4685H8.0001C7.55829 11.4685 7.20011 11.1103 7.20011 10.6685Z"
                        fill="#E04E2A"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_3151_101638">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
